// src/features/academic/components/UniversityRankingItem.jsx
import React from 'react';
import { motion } from 'framer-motion';

/**
 * University Ranking Item Component
 * Displays a single university entry in the rankings list
 */
const UniversityRankingItem = ({ 
  rank, 
  name, 
  score, 
  participants, 
  isHighlighted = false,
  animate = true
}) => {
  const baseComponent = (
    <div className={`flex items-center p-3 rounded-lg border ${
      isHighlighted 
        ? 'bg-green-50 border-green-200 ring-1 ring-green-300' 
        : 'bg-white border-gray-100 hover:bg-gray-50'
    }`}>
      <div className={`w-8 h-8 flex items-center justify-center rounded-full mr-3 ${
        rank === 1 
          ? 'bg-yellow-100 text-yellow-700' 
          : rank === 2 
          ? 'bg-gray-100 text-gray-700' 
          : rank === 3 
          ? 'bg-amber-100 text-amber-700'
          : 'bg-white text-gray-700 border border-gray-200'
      }`}>
        <span className="font-bold">{rank}</span>
      </div>
      
      <div className="flex-1">
        <div className="font-medium text-gray-800">
          {name}
          {isHighlighted && (
            <span className="ml-2 text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded-full">
              Your University
            </span>
          )}
        </div>
      </div>
      
      <div className="text-right">
        <div className="font-bold text-teal-600">
          {score.toLocaleString()}
          <span className="text-xs ml-1 font-normal">pts</span>
        </div>
        <div className="text-xs text-gray-500">
          {participants} {participants === 1 ? 'participant' : 'participants'}
        </div>
      </div>
    </div>
  );

  // Return with animation if requested
  if (animate) {
    return (
      <motion.div
        initial={{ opacity: 0, x: -10 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: rank * 0.05 }}
      >
        {baseComponent}
      </motion.div>
    );
  }
  
  return baseComponent;
};

export default UniversityRankingItem;